module.exports = function() {
  switch (process.env.NODE_ENV) {
    case 'staging':
      return {
        url: 'https://stagingapi.cellsmart.biz',
        xClientid: "GXWCksIDm6LlmZfN"
      }
    case 'production':
      return {
        url: 'https://api.cellsmart.biz',
        xClientid: "GXWCksIDm6LlmZfN"
      }
    default:
      return {
        url: 'https://stagingapi.cellsmart.biz',
        xClientid: "GXWCksIDm6LlmZfN"
      }
  }
}